

'use strict';

if (window.jQuery) var $ = window.jQuery;

$(function () {
  aweHosoren.init();

  //== DEMO ONLY
  aweSearchMenubar();
  
});

function aweMaps(mapElement) {
  if (! mapElement) {
    mapElement = '#contact-map';
  }

  var map = new GMaps({
    el: mapElement,
    lat: $(mapElement).data('lat'),
    lng: $(mapElement).data('lng'),

    draggable: true,
    scrollwheel: false
  });

  map.addMarker({
    lat: $(mapElement).data('lat'),
    lng: $(mapElement).data('lng'),
  });
}

// ===

function aweSearchMenubar() {
  var $navbar = $('.awemenu-nav');

  var $searchForm = $('#menubar-search-form');
  var $searchForm2 = $('#menubar-search-form2');
  var $openSearch = $('#open-search-form .ti-search');
  var $openSearch2 = $('#open-search-form2 .ti-search');
  var $closeSearch = $('#close-search-form');
  var $closeSearch2 = $('#close-search-form2');

  $openSearch.on('click', function(e) {
    e.preventDefault();
    $searchForm.addClass('open');

    setTimeout(function() {
      $searchForm.find('input').focus();
    }, 250);
  });
  $openSearch2.on('click', function(e) {
    e.preventDefault();
    $searchForm2.addClass('open');

    setTimeout(function() {
      $searchForm2.find('input').focus();
    }, 250);
  });

  $closeSearch.on('click', function(e) {
    e.preventDefault();
    $searchForm.removeClass('open');
  });
  $closeSearch2.on('click', function(e) {
    e.preventDefault();
    $searchForm2.removeClass('open');
  });

  $(window).resize(function() {
    if ($navbar.hasClass('awemenu-mobile')) {
      $searchForm.width('100%');
      $searchForm.css({right: '0'});
    } else {
      var $awemenu = $('.awemenu-nav .awemenu');
      var $aweicon = $('.awemenu-nav .navbar-icons');

      var width = $awemenu.width() + 50;
      var offsetRight = $aweicon.width() + 20;

      $searchForm.width(width);
      $searchForm.css({right: offsetRight});
    }
  }).trigger('resize');

}

$(document).click(function (e){
  var container = $("#menubar-search-form");
  var container2=$("#open-search-form");
  if (!container.is(e.target) && !container2.is(e.target) && container.has(e.target).length === 0  && container2.has(e.target).length === 0){ 
    $('#menubar-search-form').removeClass('open');
  }
});


// ===
function aweMainSlider() {
  var $slider = $('.main-slider');

  $slider.owlCarousel({
    items: 1,
    nav: true,
    dots: true,
    onInitialized: function() {
      $slider.find('.owl-item').each(function() {
        var $owlItem = $(this);

        var $mainSlide = $owlItem.find('.main-slider-item');
        var $mainImage = $owlItem.find('.main-slider-image > img');

        if ($mainSlide.length && $mainImage.length) {
          $mainSlide.addClass('background');
          $mainSlide.css('background-image', 'url('+$mainImage.attr('src')+')');

          $mainImage.css({
            opacity: 0,
            visibility: 'hidden'
          });
        }
      });
    }
  });
}

function awePriceSlider($selector) {
  if (! $selector) {
    $selector = $('#price-slider');
  }

  $selector.slider({
    values: [35, 250],
    min: 10,
    max: 320,
    step: 10,
    range: true,
    slide: function(e, ui) {
      $('#amount').text('$'+ui.value);
    }
  });
}

function aweBlogMasonry($selector) {
  if (! $selector) {
    $selector = $('.blog-masonry .row-masonry');
  }

  $selector.imagesLoaded(function() {
    $selector.masonry({
      itemSelector: '.column',
      columnWidth: '.column'
    });
  });
}

function aweProfolioIsotope($selector) {
  if (! $selector) {
    $selector = $('.grid');
  }

  $selector.imagesLoaded(function() {
    var $grid = $selector.isotope({
      itemSelector: '.grid-item',
      layoutMode: 'masonry'
    });
  });

  $('.awe-nav').on('click', 'a', function(e) {
    e.preventDefault();

    $(this).parents('.awe-nav').find('li').removeClass('active');
    $(this).closest('li').addClass('active');

    var filter = $(this).attr('data-filter');
    $selector.isotope({ filter: filter });
  });
}

function aweProfolioDetail() {
  $('.lasted-portfolio-carousel').owlCarousel({
    items: 4,
    nav: true,
    dots: false,
    margin: 30,
    responsive: {
      0: { items: 1 },
      480: { items: 2 },
      768: { items: 3 },
      980: { items: 4 }
    }
  });

  $('.image').magnificPopup({
    type: 'image',
    delegate: 'a',
    gallery: { enabled: true }
  });
}

function aweProductSidebar() {
  var $filterSidebar = $('#shop-widgets-filters');
  var $toggleButton = $('#open-filters');

  var $overlay = $('body').find('.widgets-filter-overlay');

  function _open() {
    $filterSidebar.addClass('open');
    $toggleButton.addClass('open');

    if (! $overlay.length) {
      $('body').append('<div class="widgets-filter-overlay"></div>');
    }

    $('body').addClass('open-filters-open');
  }

  function _close() {
    $filterSidebar.removeClass('open');
    $toggleButton.removeClass('open');
    $(document).find('.widgets-filter-overlay').remove();
    $('body').removeClass('open-filters-open');
  }

  $toggleButton.on('click', function() {
    if (! $filterSidebar.hasClass('open')) {
      _open();
    } else {
      _close();
    }
  });

  $('html').on('click', '.widgets-filter-overlay', function() {
    _close();
  });
}

function aweProductRender(thumbHorizontal) {
  if (Modernizr && ! Modernizr.touch) {
    $('.easyzoom').easyZoom();
  }

  var sMain = new Swiper('.product-slider-main', {
    loop: false,

    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev'
  });

  var sThumb = new Swiper('.product-slider-thumbs', {
    loop: false,
    centeredSlides: true,
    spaceBetween: thumbHorizontal ? 15 : 0,
    slidesPerView: thumbHorizontal ? 4 : 3,
    direction: thumbHorizontal ? 'horizontal' : 'vertical',
    slideToClickedSlide: true
  });

  sMain.params.control = sThumb;
  sThumb.params.control = sMain;
}




var selectCallback = function(variant, selector) {
  if (variant) {
    if (variant.available) {
      // Selected a valid variant that is available.
      $('#add').removeClass('disabled').removeAttr('disabled').val('Add to Cart').fadeTo(200,1);
    } else {
      // Variant is sold out.
      $('#add').val('Sold Out').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);        
    }
    // Whether the variant is in stock or not, we can update the price and compare at price.
    if ( variant.compare_at_price > variant.price ) {
      $('#price-field').html('<span class="product-price on-sale">'+ Shopify.formatMoney(variant.price, "") +'</span>'+'&nbsp;<s class="product-compare-price">'+Shopify.formatMoney(variant.compare_at_price, "")+ '</s>');
    } else {
      $('#price-field').html('<span class="product-price">'+ Shopify.formatMoney(variant.price, "") + '</span>' );
    }        
  } else {
    // variant doesn't exist.
    $('#add').val('Unavailable').addClass('disabled').attr('disabled', 'disabled').fadeTo(200,0.5);
  }
}

$(".swiper-container").each( function(){
  var config = {
    spaceBetween: $(this).data('margin'),
    slidesPerView: $(this).data('items'),
    direction: $(this).data('direction'),
    paginationClickable: true,
    grabCursor: true 
  };		
  var swiper = new Swiper(this, config);

});


// ================== New lable=============
$('.product .product-inner').each(function(){

  var pubDate = $(this).data("publish-date");
  var pubDate2=pubDate.substr(0, 10);
  var todayDate = new Date();
  var time1 = Date.parse(pubDate2);
  var time2 = Date.parse(todayDate);
  var time= Math.abs(time2 - time1);
  var a= 1*24*60*60*1000;

  if(time < a){
    $('.product .product-inner .new').show();

  }
});

$(document).ready(function(){
  if($(".product-body-list").children().length > 0){

    $('.view-mode .grid').removeClass('active');
    $('.view-mode .list').addClass('active');
  }
});




/* Promotion Countdown */
jQuery(document).ready(function($) {
  $.fn.ENGO_CountDown = function( options ) {
    return this.each(function() {
      // get instance of the ENGO_CountDown.
      new  $.ENGO_CountDown( this, options );
    });
  }
  $.ENGO_CountDown = function( obj, options ){
    var ddiff, gsecs;
    this.options = $.extend({
      autoStart           : true,
      LeadingZero:true,
      DisplayFormat:"<div><span>%%D%%</span> Days</div><div><span>%%H%%</span> Hours</div><div><span>%%M%%</span> Mins</div><div><span>%%S%%</span> Secs</div>",
      FinishMessage:"Expired",
      CountActive:true,
      TargetDate:null
    }, options || {} );
    if( this.options.TargetDate == null || this.options.TargetDate == '' ){
      return ;
    }
    this.timer  = null;
    this.element = obj;
    this.CountStepper = -1;
    this.CountStepper = Math.ceil(this.CountStepper);
    this.SetTimeOutPeriod = (Math.abs(this.CountStepper)-1)*1000 + 990;
    var dthen = new Date(this.options.TargetDate);
    var dnow = new Date();
    if( this.CountStepper > 0 ) {
      ddiff = new Date(dnow-dthen);
    }
    else {
      ddiff = new Date(dthen-dnow);
    }
    gsecs = Math.floor(ddiff.valueOf()/1000);
    this.CountBack(gsecs, this);
  };
  $.ENGO_CountDown.fn =  $.ENGO_CountDown.prototype;
  $.ENGO_CountDown.fn.extend =  $.ENGO_CountDown.extend = $.extend;
  $.ENGO_CountDown.fn.extend({
    calculateDate:function( secs, num1, num2 ){
      var s = ((Math.floor(secs/num1))%num2).toString();
      if ( this.options.LeadingZero && s.length < 2) {
        s = "0" + s;
      }
      return "<b>" + s + "</b>";
    },
    CountBack:function( secs, self ){
      var DisplayStr;
      if (secs < 0) {
        self.element.innerHTML = '<div class="labelexpired"> '+self.options.FinishMessage+"</div>";
        return;
      }
      clearInterval(self.timer);
      DisplayStr = self.options.DisplayFormat.replace(/%%D%%/g, self.calculateDate( secs,86400,100000) );
      DisplayStr = DisplayStr.replace(/%%H%%/g, self.calculateDate(secs,3600,24));
      DisplayStr = DisplayStr.replace(/%%M%%/g, self.calculateDate(secs,60,60));
      DisplayStr = DisplayStr.replace(/%%S%%/g, self.calculateDate(secs,1,60));
      self.element.innerHTML = DisplayStr;
      if (self.options.CountActive) {
        self.timer = null;
        self.timer =  setTimeout( function(){
          self.CountBack((secs+self.CountStepper),self);
        },( self.SetTimeOutPeriod ) );
      }
    }

  });

  function init_countdown() {
    /** Countdown **/
    $('[data-countdown="countdown"]').each(function(index, el) {
      var $this = $(this);
      var $date = $this.data('date').split("-");
      $this.ENGO_CountDown({
        TargetDate:$date[0]+"/"+$date[1]+"/"+$date[2]+" "+$date[3]+":"+$date[4]+":"+$date[5],
        DisplayFormat:"<li><span>%%D%% </span>days</li><li><span>%%H%% </span>hours</li><li><span>%%M%% </span>mins</li><li><span>%%S%% </span>secs</li>",
        FinishMessage: "Expired"
      });
    });



  }
  init_countdown();
});
//===============//
$('.section-link li').click(function(e){
  e.preventDefault();
  var index = $(this).attr('data-t');
  $(this).parent().find('li').removeClass('active');
  $(this).addClass('active');
  $(this).parent().parent().find('.section-content .tab-content').each(function(){
    var tab = $(this).attr('data-content');
    if(index == tab){
      $(this).parent().find('.tab-content').removeClass('active');
      $(this).addClass('active');
    }
  });
});

$('.flipster-carousel').flipster({
  style: 'flat',
  spacing: -0.05,
  nav: true,
  scrollwheel: false
});
$(window).scroll(function(){ 
  if ($(this).scrollTop() > 20) { 
    $('.awemenu-nav').css("background","#fff");
    // -----end------------
  } else { 
    $('.awemenu-nav').css("background","transparent");
  } 
}); 
//   ================
var $status = $('.pagingInfo');
var $slickElement = $('.slider-home7');
$slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
  //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
  var i = (currentSlide ? currentSlide : 0) + 1;
  $status.html('<span class="dot_current">0' + i  + '</span>' + '<span>0' +slick.slideCount + '</span>');
});
$('.slider-home7').on('afterChange', function(event, slick, currentSlide) {
  $('.slick-active').append('<div class="pagingInfo"');
});
//   ============
// ---------slide  home 7-------------
$('.slider-home7').slick({
  dots:true,
  infinite: true,
  autoplay:false,
  slidesToShow: 1,
  speed: 1000,
  fade: true,
  customPaging : function(slider, i) {
    var thumb = $(slider.$slides[i]).data();
    return '<a></a>';
  },
});
// ---------end-----------
// -----slide product home 6---------
$('.slick-newarrival').slick({
  dots: false,
  infinite: false,
  autoplay:false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,


  responsive: [
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 567,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
// -----------end------------
// -----slide comment---------
$('.slider-comment').slick({
  dots: false,
  infinite: true,
  autoplay:true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,


  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
// -----------end------------
/* ============= style document ============= */
$(function () {
  $('.icon_op_doc').on('click', function() {
    if($(this).attr('data-click-state') == 0) {
      $(this).attr('data-click-state', 1);
      $('.content_doc_hs').addClass("active");
      $('.promo-btn').addClass("active");
      $('.over-lay').addClass('active');
    } else {
      $(this).attr('data-click-state', 0);
      $('.content_doc_hs').removeClass("active");
      $('.promo-btn').removeClass("active");
      $('.over-lay').removeClass('active');
    }
  });
});
$('.over-lay').on('click', function() {
  $('.icon_op_doc').attr('data-click-state', 0);
  $('.promo-btn').removeClass("active");
  $('.over-lay').removeClass('active');
  $('.content_doc_hs').removeClass("active");
});

$('.js-info-h31').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: '.js-img-h31',
  prevArrow: '<button type="button" class="carousel-prev"><span class="ti-angle-left"></span></button>',
  nextArrow: '<button type="button" class="carousel-next"><span class="ti-angle-right"></span></button>',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        arrows: false,
      }
    }
  ]
});
$('.js-img-h31').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: '.js-info-h31',
  focusOnSelect: true,
  arrows: false,
  autoplay: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        dots: true,
      }
    }
  ]
});
var dataImg = $('.js-img-h31').find('.slick-current').prev().find('.img-main').attr('src');
$('.slideshow-h31').find('.js-sub-img').children().attr('src',dataImg);
$('.js-img-h31').on('afterChange',function(){
  var dataImg = $('.js-img-h31').find('.slick-current').prev().find('.img-main').attr('src');
  $('.slideshow-h31').find('.js-sub-img').children().attr('src',dataImg);
})
$('.js-sub-img').on('click',function(){
  $('.carousel-prev').click();
})
$('.js-product-h31').slick({
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 4,
  prevArrow: '<button type="button" class="carousel-prev"><span class="ti-angle-left"></span></button>',
  nextArrow: '<button type="button" class="carousel-next"><span class="ti-angle-right"></span></button>',
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true
      }
    }
  ]
})


$('.slick_product_h39_banner').slick({
  arrows: true,
  infinite: false,
  dots: true ,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow:'<button type="button" class="prev-slide"><i class="ti-angle-left"></i> </button>',
  nextArrow:'<button type="button" class="next-slide"> <i class="ti-angle-right"></i></button>',
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
        dots: false ,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        dots: false ,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        dots: false ,

      }
    }
  ]
});


$('.slick-side-h1').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3500,
  dots: true,
  arrows: true,
  fade: true,
  prevArrow:'<button type="button" class="prev-slide"><i class="ti-angle-left"></i> </button>',
  nextArrow:'<button type="button" class="next-slide"> <i class="ti-angle-right"></i></button>',
  responsive: [

    {
      breakpoint: 1200,
      settings: {
        infinite: true,
        dots: true ,
        arrows: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        dots: true ,
        arrows: false
      }
    },
    {
      breakpoint:600,
      settings: {
        dots: true ,
        arrows: false,
        autoplay: true,
      }
    }
  ]
});

$('.js-testi').slick({
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  fade: true,
  prevArrow: '<button type="owl-prev" class="carousel-prev"><span class="ti-angle-left"></span></button>',
  nextArrow: '<button type="owl-next" class="carousel-next"><span class="ti-angle-right"></span></button>',
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        arrows: false,
      }
    }
  ]
})
$('.js-slide-h40').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  prevArrow: '<button type="button" class="carousel-prev"><span class="ti-angle-left"></span></button>',
  nextArrow: '<button type="button" class="carousel-next"><span class="ti-angle-right"></span></button>',

  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000  
      }
    },
  ]
});
$('.js-slide-h40 .js-change').eq(0).children('.img-item').addClass('active');
$('.slide-h40 .paginate span').eq(0).addClass('active');
$('.js-slide-h40').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  var mySlideNumber = nextSlide;
  var prev = mySlideNumber - 1;
  $('.slide-h40 .paginate span').removeClass('active');
  $('.slide-h40 .paginate span').eq(mySlideNumber).addClass('active');
  setTimeout(function(){
    $('.js-slide-h40 .js-change').eq(prev).children('.img-item').removeClass('active');
  },350);
  $('.js-slide-h40 .js-change').eq(mySlideNumber).children('.img-item').addClass('active');
});

$('.js-slide-h41').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  fade: true,
  prevArrow: '<button type="button" class="carousel-prev"><span class="ti-angle-left"></span></button>',
  nextArrow: '<button type="button" class="carousel-next"><span class="ti-angle-right"></span></button>',

  responsive: [
    {
      breakpoint: 1200,
      settings: {
        arrows: false, 
      }
    },
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000  
      }
    }
  ]
});
$('.js-slide-h41 .js-change').each(function(){
  var data = parseInt($(this).attr('data-slick-index')) - 1
  $(this).children('.img-item').children().attr('src',function(){
    return $('.js-slide-h41 .js-change').eq(data).children('img').attr('src')
  })
})
$('.js-slide-h41 .js-change').eq(0).children('.img-item').addClass('active')
$('.js-slide-h41 .info .info-content').eq(0).children().addClass('active')
$('.js-slide-h41 .info').eq(0).children().addClass('active')
$('.slide-h41 .paginate span').eq(0).addClass('active');
$('.js-slide-h41').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
  var mySlideNumber = nextSlide;
  var prev = mySlideNumber - 1
  $('.slide-h41 .paginate span').removeClass('active')
  $('.slide-h41 .paginate span').eq(mySlideNumber).addClass('active')
  setTimeout(function(){
    $('.js-slide-h41 .js-change').eq(prev).children('.img-item').removeClass('active')
    $('.js-slide-h41 .info .info-content').eq(prev).children().removeClass('active')
    $('.js-slide-h41 .info').eq(prev).children().removeClass('active')
  },350);
  $('.js-slide-h41 .js-change').eq(mySlideNumber).children('.img-item').addClass('active')
  $('.js-slide-h41 .info .info-content').eq(mySlideNumber).children().addClass('active')
  $('.js-slide-h41 .info').eq(mySlideNumber).children().addClass('active')
})

/* =======end========== */